import { createWebHashHistory, createRouter } from "vue-router";
import Home from "@/views/MainView.vue";
// @ts-ignore
import PrintBill from "../../public/Prints/bill/Bill.vue";
// @ts-ignore
import PrintReceipt from "../../public/Prints/Receipts/PrintReceipt.vue";
import trade from "../../public/Prints/Trade-Permit/TradePermit.vue";


const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: {public: false}
    },
    {
        path: "/bill",
        name: "bill",
        component: PrintBill,
    },
    {
        path: "/receipt",
        name: "receipt",
        component: PrintReceipt,
    },
    {
        path: '/trade/:data?',
        name: "trade",
        component: trade,
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});


export default router;